import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSwap = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 18.75H3.75V15H0V18.75ZM0 26.25H3.75V22.5H0V26.25ZM3.75 33.75V30H0C0 32.0625 1.66875 33.75 3.75 33.75ZM0 11.25H3.75V7.5H0V11.25ZM22.5 33.75H26.25V30H22.5V33.75ZM30 0H11.25C9.16875 0 7.5 1.6875 7.5 3.75V22.5C7.5 24.5625 9.16875 26.25 11.25 26.25H30C32.0625 26.25 33.75 24.5625 33.75 22.5V3.75C33.75 1.6875 32.0625 0 30 0ZM30 22.5H11.25V3.75H30V22.5ZM15 33.75H18.75V30H15V33.75ZM7.5 33.75H11.25V30H7.5V33.75Z",
		fill: "#7591AD"
	})
});
export default SvgSwap;
